import { useEffect } from 'react';
import { BrowserRouter, useLocation, useRoutes } from 'react-router-dom';

import routeConfig from './routes';
import { trackRouteView } from '../services/analytics';

const AppRoutes = () => {
  const routes = useRoutes(routeConfig);
  return routes;
};

const RouteAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    trackRouteView({
      pathname: location.pathname,
      search: location.search
    });
  }, [location.pathname, location.search]);

  return null;
};

function Router() {
  return (
    <BrowserRouter>
      <RouteAnalytics />
      <AppRoutes />
    </BrowserRouter>
  );
}

export default Router;
